import { Icon, IconNames } from '@dixa/lib-shared-habla';
import { ConversationsChannels } from 'lib-shared-legacy-types';
import { ComponentProps } from 'react';

export const conversationChannelIconMap: Record<
  ConversationsChannels,
  IconNames
> = {
  adachat: 'messenger',
  pstnphone: 'phone',
  email: 'mail',
  widgetchat: 'chat',
  messenger: 'messenger',
  facebookmessenger: 'facebook-messenger',
  whatsapp: 'whatsapp',
  sms: 'sms',
  callback: 'callback',
  voicemail: 'voicemail',
  contactform: 'chat-widget',
  twitter: 'twitter',
};

type ConversationChannelIconProps = {
  channel: ConversationsChannels;
} & Partial<ComponentProps<typeof Icon>>;

export const ConversationChannelIcon = ({
  channel,
  ...iconProps
}: ConversationChannelIconProps): JSX.Element => (
  <Icon {...iconProps} name={conversationChannelIconMap[channel]} />
);
